//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShopsList from "@/components/pages/storeFinder/ShopsList/index";
import ShopView from "@/components/pages/storeFinder/ShopView/index";
import {mapGetters} from "vuex";
import breakpointsListMixin from '~/mixins/breakpointsList.mixin';

export default {
    name: "StoreFinder",
    components: {ShopView, ShopsList},
    mixins: [
        breakpointsListMixin,
    ],
    data() {
        return {
            activeShop: {},
            coordinate: {
                distance: "20km",
                latitude: 50.4501,
                longitude: 30.5234,
            },
        }
    },
    computed: {
        ...mapGetters({
            stores: 'storefinder/getStoresList',
            currentShop: 'storefinder/getActiveStore',
            currentPage: 'storefinder/getCurrentPage',
        }),
        shops() {
            return [
                {
                    id: '9990004965',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗ',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '9990004965',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '9990004961',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '14',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '15',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '16',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '17',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '18',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '19',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
                {
                    id: '20',
                    title: 'ADIDAS KIDS, ТЦ ОКЕАН ПЛАЗА',
                    address: 'Горького 176, Київ, 3680',
                    phone: '+38 044 000 00 00',
                    workHours: [],
                    active: false
                },
            ]
        },
        notHasActive() {
            return !this.currentShop.id
        }
    },
    methods: {
        setActiveShop(shop) {
            let idNum = shop.id.match(/\d/g);
            idNum = idNum.join("");
            this.$store.dispatch('storefinder/fetchActiveStore', idNum);
        },
        updateCoords(data) {
            this.coordinate.latitude = data.latitude;
            this.coordinate.longitude = data.longitude;
        },
        getYourLocate() {
            navigator.geolocation.getCurrentPosition(function(position) {
                this.updateCoords(position.coords)
            }.bind(this));
        },
        loadMore() {
            this.loadStoresData(this.currentPage + 1)
        },
        loadStoresData(page) {
            let params = {
                page: page,
                body: {
                    "nearGeoLocationRequest": this.coordinate
                }
            }
            this.$store.dispatch('storefinder/fetchStoresData', params)
        }
    },
    watch: {
        'coordinate.longitude':{
            handler(newVal){
                this.loadStoresData(0)
            },
            immediate: true
        },
        'stores': {
            handler(newVal) {
                if (newVal[0] && this.currentPage <= 0 && this.laptopSmallUp) {
                    this.setActiveShop(this.stores[0]);
                }
            }
        }
    },
    mounted() {
        this.loadStoresData(0)
        this.getYourLocate()
    },
}
